import moment from 'moment-timezone';
import React, { useContext, useEffect, useRef, useState } from 'react';
import AuthContext from '../../../hooks/authContext';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { CommonConfirmationDialog, CommonSuccessDialog, DragReschduleConfirm } from '../../../components/DialogComponent/SupplyDataDialog';
import { calculateDurationInMinutes, filterAppointments, formatSelectedDateTime } from '../../../services/helpers';
import { getOneAppointment, updateAppointments } from '../../../services/apiservices/appoinments';
import CommonContext from '../../../hooks/commonContext';
import { Switch } from '@material-ui/core';
import { useMediaQuery } from '@mui/material';

const ITEM_TYPE = 'APPOINTMENT';

const DraggableAppointment = ({ index, filteredAppointments, appointment, client, boxHeight, setIsModalOpen, setSelectedAppointment, settingsData, topPosition }) => {
    const [, drag] = useDrag({
        type: ITEM_TYPE,
        item: { appointment },
    });

    return (
        <div
            ref={drag}
            className="appointmentView"
            style={{
                height: `${boxHeight}px`,
                width: `calc(100% / ${filteredAppointments})`,
                left: `${(index % filteredAppointments) * (100 / filteredAppointments)}%`,
                top: `${topPosition}%`,
            }}
            key={`appointment-${appointment.id}`}
            onClick={() => {
                setIsModalOpen(true);
                setSelectedAppointment(appointment);
            }}
        >
            <div className="appointmentView-title">{client?.clientName}</div>
            <div className="appointmentView-details2 mv-10">
                {appointment.apoointmentDetails?.forms[0]?.values[1]?.value} - {appointment.apoointmentDetails?.forms[0]?.values[2]?.value}
            </div>
            <div className="appointmentView-details mv-10">{appointment.apoointmentDetails.shiftName}</div>
            <div className="appointmentView-details2 mv-10">
                {settingsData?.timeFormat === '24hrs' ? moment(appointment.apoointmentDetails.time, 'h:mm A').format('HH:mm') : appointment.apoointmentDetails.time} - {settingsData?.timeFormat === '24hrs' ? moment(appointment.apoointmentDetails.endTime, 'h:mm A').format('HH:mm') : appointment.apoointmentDetails.endTime}
            </div>
        </div>
    );
};

const DroppableTimeSlot = ({ hour, day, timezone, onDrop, children, laptop }) => {
    const slotRef = useRef(null);
    const [, drop] = useDrop({
        accept: ITEM_TYPE,
        drop: (item, monitor) => {
            const { appointment } = item;
            const clientOffset = monitor.getClientOffset();
            
            const slotRect = slotRef.current.getBoundingClientRect();
            const offsetY = clientOffset.y - slotRect.top;
            const slotHeight = laptop ? 80 : 100;
            const quarterHeight = slotHeight / 4;
            
            const differenceFromOld = monitor.getDifferenceFromInitialOffset();
            const timeOld = moment(appointment.apoointmentDetails.time, "hh:mm a");
            const minutesOld = timeOld.hours() * 60 + timeOld.minutes();

            const calPoint = 60 * differenceFromOld.y / slotHeight;
            const finalMins = minutesOld + calPoint;
            
            const nearest15Mins = Math.round(finalMins / 15) * 15;
            const timeNew = moment().startOf('day').add(nearest15Mins, 'minutes');
            
            let adjustedHour = hour;
            let adjustedMinutes = 0;
            
            adjustedHour = timeNew.format("HH");
            adjustedMinutes = timeNew.format("mm");
            // const { appointment } = item;
            // const clientOffset = monitor.getClientOffset();

            // const slotRect = slotRef.current.getBoundingClientRect();

            // const offsetY = clientOffset.y - slotRect.top;

            // const slotHeight = laptop ? 80 : 100;
            // const quarterHeight = slotHeight / 4;

            // let adjustedHour = hour;
            // let adjustedMinutes = 0;

            // if (offsetY < quarterHeight) {
            //     adjustedMinutes = 0;
            // } else if (offsetY < quarterHeight * 2) {
            //     adjustedMinutes = 15;
            // } else if (offsetY < quarterHeight * 3) {
            //     adjustedMinutes = 30;
            // } else {
            //     adjustedMinutes = 45;
            // }

            onDrop(item.appointment, adjustedHour, day, timezone, adjustedMinutes);
        },
    });

    useEffect(() => {
        drop(slotRef.current);
    }, [drop]);

    return (
        <div ref={slotRef} className="time-slot">
            <div className='border-none border-b border-dotted border-[#ddd] dark:border-none' style={{height:"50%"}}></div>
            {children}
        </div>
    );
};


const WeekView = ({ weeksAllDays, clientDetails, empNames, fetchAppointments, clientName, employeeDetails, settingsData }) => {
    // const timeSlots = Array.from({ length: 13 }, (_, i) => i + 7);
    const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const [widths, setWidths] = useState([]);
    const [appointmentsData, setAppointmentsData] = useState();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [timeZoneDialog, setTimeZoneDialog] = useState(false);
    const [loading, setLoading] = useState(true);
    const [selectData, setSelectData] = useState();
    const commonContext = useContext(CommonContext);
    const [showSlots, setShowSlots] = useState(false);
    const [showEarlyAppt, setShowEarlyAppt] = useState(false);
    const [showLateAppt, setShowLateAppt] = useState(false);
    const [outsideWorkAlert, setOutsideWorkAlert] = useState(false);
    const timeZones = [
        { label: "EDT - Eastern", value: "America/New_York" },
        { label: "CDT - Central", value: "America/Chicago" },
        { label: "MDT - Mountain", value: "America/Denver" },
        { label: "PDT - Pacific", value: "America/Los_Angeles" }
    ];
    const auth = useContext(AuthContext);
    const appointments = auth?.appointmentsData;
    const setIsModalOpen = auth.setIsModalOpen;
    const setSelectedAppointment = auth.setSelectedAppointment;
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const laptop = useMediaQuery('(max-width:1801px)');

    const minuteToPercentageMap = {
        0: 0,
        15: 25,
        30: 50,
        45: 75
    };

    const formatTime = (hour) => {
        if (settingsData?.timeFormat === '24hrs') {
            return `${hour}`;
        } else {
            const ampm = hour >= 12 ? 'pm' : 'am';
            const formattedHour = hour % 12 || 12;
            return `${formattedHour}${ampm}`;
        }
    };

    function convertTo24Hour(timeString) {
        const [time, modifier] = timeString?.split(" ");
        let [hours] = time?.split(":");

        const normalizedModifier = modifier.toUpperCase();

        hours = parseInt(hours);

        if (normalizedModifier === "PM" && hours !== 12) {
            hours += 12;
        }
        if (normalizedModifier === "AM" && hours === 12) {
            hours = 0;
        }

        return hours;
    }

    const standardStartHour = settingsData?.startTime ? convertTo24Hour(settingsData?.startTime) : 9;
    const standardEndHour = settingsData?.endTime ? convertTo24Hour(settingsData?.endTime) : 17;

    const generateTimeSlots = () => {
        const slots = [];

        if (!showSlots) {
            for (let i = 8; i <= 22; i++) {
                slots.push(i);
            }
        }

        if (showSlots) {
            for (let i = 0; i <= 23; i++) {
                slots.push(i);
            }
        }

        return slots;
    };

    const getAppointmentsForDay = (date) => {
        if (Array.isArray(appointments)) {
            const weekDateString = moment(date).format("YYYY-MM-DD");

            const filteredAppointments = appointments.filter((item) => {
                const appointmentDateString = moment(item.apoointmentDetails.date).format("YYYY-MM-DD");
                return appointmentDateString === weekDateString;
            });

            const normalizedDate = moment(date).startOf('day').format("YYYY-MM-DD");

            return filteredAppointments.filter((item) => {
                const appointmentDate = moment(item.apoointmentDetails.date).startOf('day').format("YYYY-MM-DD");
                return appointmentDate === normalizedDate;
            });
        }
        return [];
    };

    useEffect(() => {
        const calculateWidths = async () => {
            const widthsArray = [];
            let hasEarlyAppointments = false;
            let hasLateAppointments = false;

            const standardStartTime = moment({ hour: standardStartHour, minute: 0 });
            const standardEndTime = moment({ hour: standardEndHour, minute: 0 });
            const staticWidths = laptop ? 180 : 250;
            weeksAllDays.forEach((day) => {
                const dailyAppointments = getAppointmentsForDay(day);

                timeZones.forEach((timezone) => {
                    const timezoneAppointments = dailyAppointments.filter(
                        (appointment) =>
                            (appointment.apoointmentDetails.calendarTimezone || "America/New_York") === timezone.value
                    );

                    let maxOverlaps = 0;

                    timezoneAppointments.forEach((appointment) => {
                        const start = moment(appointment.apoointmentDetails.time, "hh:mm a").tz(timezone.value);
                        const end = moment(appointment.apoointmentDetails.endTime, "hh:mm a").tz(timezone.value);

                        if (start.isBefore(standardStartTime)) {
                            hasEarlyAppointments = true;
                        }

                        if (end.isAfter(standardEndTime)) {
                            hasLateAppointments = true;
                        }

                        const overlappingAppointments = timezoneAppointments.filter((other) => {
                            const otherStart = moment(other.apoointmentDetails.time, "hh:mm a").tz(timezone.value);
                            const otherEnd = moment(other.apoointmentDetails.endTime, "hh:mm a").tz(timezone.value);
                            return (
                                start.isBefore(otherEnd) &&
                                end.isAfter(otherStart) &&
                                appointment !== other
                            );
                        });

                        maxOverlaps = Math.max(maxOverlaps, overlappingAppointments.length + 1);
                    });

                    const width = Math.max(staticWidths, maxOverlaps * 250);
                    widthsArray.push(width);
                });
            });

            setWidths(widthsArray);
            setShowEarlyAppt(hasEarlyAppointments);
            setShowLateAppt(hasLateAppointments);
            setShowSlots(hasEarlyAppointments || hasLateAppointments);
        };

        setLoading(true);
        calculateWidths().then(() => setLoading(false));
    }, [weeksAllDays, employeeDetails, appointments]);

    const handleDrop = async (appointment, newHour, newDate, newTimezone, adjustedMinutes) => {
        const inactiveEmp = employeeDetails?.find((emp) => emp?.userId === appointment?.userId);
        const currentDateTime = moment().utc();
        const appointmentDateTime = moment.utc(
            `${appointment?.apoointmentDetails?.date} ${appointment?.apoointmentDetails?.time}`,
            "MMMM DD, YYYY hh:mm A"
        );
        const isDateValid = appointmentDateTime.isSameOrAfter(currentDateTime);
        if (appointment.source !== "proteams" || inactiveEmp.status === false || !isDateValid) {
            setAlertOpen(true);
            return;
        } else {
            const startHour = moment({ hour: newHour, minute: adjustedMinutes });
            const duration = appointment.apoointmentDetails.duration;
            const endHour = startHour.clone().add(duration, "minutes");

            const workStartTime = moment({ hour: standardStartHour, minute: 0 });
            const workEndTime = moment({ hour: standardEndHour, minute: 0 });

            const isOutsideWorkHours = startHour.isBefore(workStartTime) || endHour.isAfter(workEndTime);

            if (settingsData?.standardWorkTime === 'no' && isOutsideWorkHours) {
                setOutsideWorkAlert(true);
            } else {
                const data = await getOneAppointment(appointment?.id, 'appoinments');
                setSelectData(data?.appointment);

                const prevHistory = data?.historyDate || [];
               const updatedHistory = prevHistory.includes(data?.appointmentDateTime) ? prevHistory : [...prevHistory, data?.appointmentDateTime];

                const formattedStartTime = startHour.format('hh:mm A');
                const formattedEndTime = endHour.format('hh:mm A');
                const date = moment(newDate).format('MM/DD/YYYY');
                const appointmentDateTime = formatSelectedDateTime(date, formattedStartTime, newTimezone);

                setDialogOpen(true);

                setAppointmentsData({
                    ...data.appointment,
                    time: formattedStartTime,
                    endTime: formattedEndTime,
                    type: "One Time",
                    date: moment(newDate).format('LL'),
                    appointmentDateTime: appointmentDateTime,
                    calendarTimezone: newTimezone,
                    historyDate: updatedHistory,
                })
            }
        }
    };

    const handelConfirmCloseDialog = () => {
        setDialogOpen(false);
        setAppointmentsData();
        setSelectData();
    }
    const handelTimezoneConfirmcancel = () => {
        setTimeZoneDialog(false);
        setAppointmentsData();
        setSelectData();
    }
    const handelAlertClose = () => {
        setAlertOpen(false);
        setAppointmentsData();
        setSelectData();
    }

    const handelOutsideWorkAlertClose = () => {
        setOutsideWorkAlert(false);
        setAppointmentsData();
        setSelectData();
    }

    const handelConfirmUpdateDilog = async () => {
        const oldTimezone = timeZones.find((item) => item.value === selectData.calendarTimezone)?.label;
        const newTimezone = timeZones.find((item) => item.value === appointmentsData.calendarTimezone)?.label;
        const timeZoneConflict = oldTimezone !== newTimezone;

        setDialogOpen(false);
        if (timeZoneConflict) {
            setTimeZoneDialog(true);
        } else {
            commonContext?.setLoader(true);
            try {
                const ids = appointmentsData?.id;
                const response = await updateAppointments(appointmentsData, null, ids);
                if (response.success) {
                    setAppointmentsData();
                    setSelectData();
                    await delay(3500);
                    await fetchAppointments();
                } else {
                    console.error("Failed to update appointment:", response.error);
                    setAppointmentsData();
                    setSelectData();
                }
            } catch (error) {
                console.error("Error updating appointment:", error);
            } finally {
                commonContext?.setLoader(false);
            }
        }
    };


    const handelClickTimezoneConfirm = async () => {
        setTimeZoneDialog(false);
        commonContext?.setLoader(true);
        try {
            const ids = appointmentsData?.id;
            const response = await updateAppointments(appointmentsData, null, ids);
            if (response.success) {
                setAppointmentsData();
                setSelectData();
                await delay(3500);
                await fetchAppointments();
            } else {
                console.error("Failed to update appointment:", response.error);
                setAppointmentsData();
                setSelectData();
            }
        } catch (error) {
            console.error("Error updating appointment:", error);
        } finally {
            commonContext?.setLoader(false);
        }
    }

    const timeSlots = generateTimeSlots();
    const TimeColumn = () => {
        return (
            timeSlots.map((hour, index) => (
                <div key={`time-slot-${index}`} className={`time-column ${hour < standardStartHour ? 'early-slot' : ''} ${hour > standardEndHour ? 'late-slot' : ''}`}>
                    {formatTime(hour)}
                </div>
            ))
        );
    };

    const isGridReady = widths.length === weeksAllDays.length * timeZones.length;

    return (
        <>
            {/* {loading || !isGridReady ? (
                // commonContext?.setLoader(true)
                null
            ) : ( */}
                <>
                    <DndProvider backend={HTML5Backend}>
                        {/* {commonContext?.setLoader(false)} */}
                        <div className='mainCalendarContair'>
                            <div className='mainContainer dark:bg-[#1A1F2C]'>
                                <div className='newTimeColumn2 dark:bg-[#1A1F2C]' style={{ top: auth.isExpanded ? "-1px" : 0 }}>
                                    <div className="grid-row-day dark:bg-[#1A1F2C] dark:text-white" style={{ display: "grid", width: widths?.length > 0 ? "fit-content" : "", gridTemplateColumns: `80px ${widths?.map((width, index) => `${width}px`).join(" ")}` }}>
                                        <div className="time-column newTimeColumn3 dark:bg-[#1A1F2C] dark:text-white" style={{ height: "25px", borderTop: "2px solid #ddd", padding:"0" }}>
                                                <Switch
                                                    checked={showSlots}
                                                    onChange={(e) => setShowSlots(e.target.checked)}
                                                    color='primary'
                                                    size='small'
                                                />
                                        </div>

                                        {weeksAllDays?.map((day, index) => (
                                            <div key={`day-${index}`} className="day-header dark:bg-[#1A1F2C] dark:text-white" style={{ gridColumn: 'span 4' }}>
                                                {moment(day).format("dddd MMM D")}
                                            </div>
                                        ))}
                                    </div>

                                    <div className="grid-row-Time dark:bg-[#1A1F2C] dark:text-white" style={{ display: "grid", gridTemplateColumns: `80px ${widths?.map((width, index) => `${width}px`).join(" ")}` }}>
                                        <div className="time-column newTimeColumn3 dark:bg-[#1A1F2C] dark:text-white" style={{ height: "25px" }}><AccessTimeIcon fontSize="small" /></div>
                                        {weekDays?.map(day =>
                                            timeZones?.map((timezone, timezoneIndex) => (
                                                <div key={`${day}-${timezoneIndex}`} className="timezone-header dark:text-white">
                                                    {`${day.slice(0, 3)} ${timezone?.label?.split(" ")[0]}`}
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                                {showEarlyAppt && (<div className="early-border" />)}
                                <div className="calendar-container dark:bg-[#1A1F2C] dark:text-white d-flex">
                                    <div className='newTimeColumn dark:bg-[#1A1F2C] dark:text-white'>
                                        <TimeColumn />
                                    </div>
                                    <div>
                                        {timeSlots?.map((hour) => (
                                            <div
                                                key={hour}
                                                style={{ display: "grid", gridTemplateColumns: `${widths?.map((width) => `${width}px`).join(" ")}`, 
                                                // backgroundColor:
                                                // hour >= standardStartHour && hour < standardEndHour
                                                //     ? "white"
                                                //     : "#eee",
                                                    }}
                                                    className={`${
                                                        hour >= standardStartHour && hour < standardEndHour
                                                        ? 'bg-white dark:bg-[#1A1F2C]'
                                                        : 'bg-gray-100 dark:bg-gray-600'
                                                    }`}>
                                                {weeksAllDays?.map((day, dayIndex) => {
                                                    const dailyAppointments = getAppointmentsForDay(day);

                                                    return timeZones?.map((timezone, timezoneIndex) => {
                                                        const timezoneAppointments = dailyAppointments.filter((appointment) =>
                                                            (appointment.apoointmentDetails.calendarTimezone) === timezone.value
                                                        );

                                                        const filteredAppointments = filterAppointments(timezoneAppointments, clientName, empNames);

                                                        return (
                                                            <DroppableTimeSlot
                                                                key={`slot-${dayIndex}-${timezoneIndex}`}
                                                                hour={hour}
                                                                day={day}
                                                                timezone={timezone.value}
                                                                onDrop={handleDrop}
                                                                laptop={laptop}
                                                            >
                                                                {filteredAppointments?.map((appointment, index) => {
                                                                    const clientId = appointment.apoointmentDetails.clientId ? appointment.apoointmentDetails.clientId : appointment.clientId;
                                                                    const client = clientDetails?.find((client) => client.id === clientId);
                                                                    const appointmentTimeSlot = settingsData?.timeFormat === '24hrs' ? moment(appointment.apoointmentDetails.time, 'h:mm A').hour() : moment(appointment.apoointmentDetails.time, "hh:mm A").hour();
                                                                    const appointmentStartTime = appointment.apoointmentDetails.time;
                                                                    let appointmentEndTime = appointment.apoointmentDetails.endTime;
                                                                    const cutoffTime = moment(showSlots ? "11:00 pm" : standardEndHour, "h:mm a");
                                                                    const endTimeMoment = moment(appointmentEndTime, "h:mm a");
                                                                    if (endTimeMoment.isAfter(cutoffTime)) {
                                                                        appointmentEndTime = cutoffTime.format("h:mm a");
                                                                    }
                                                                    const duration = calculateDurationInMinutes(appointmentStartTime, appointmentEndTime);
                                                                    const time = moment(appointmentStartTime, "hh:mm a");
                                                                    const minuteStart = time.minute();
                                                                    const topPosition = minuteToPercentageMap[minuteStart] ?? 0;
                                                                    const boxHeight = (duration / 60) * (laptop ? 80 : 100);
                                                                    if (appointmentTimeSlot === hour) {
                                                                        return (
                                                                            <DraggableAppointment
                                                                                key={`appointment-${dayIndex}-${index}`}
                                                                                index={index}
                                                                                filteredAppointments={filteredAppointments.length}
                                                                                appointment={appointment}
                                                                                client={client}
                                                                                boxHeight={boxHeight}
                                                                                setIsModalOpen={setIsModalOpen}
                                                                                setSelectedAppointment={setSelectedAppointment}
                                                                                settingsData={settingsData}
                                                                                topPosition={topPosition}

                                                                            />
                                                                        );
                                                                    }
                                                                })}
                                                            </DroppableTimeSlot>
                                                        );
                                                    });
                                                })}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {showLateAppt && (<div className="late-border" />)}
                            </div>
                        </div>
                    </DndProvider>
                </>
            {/* )} */}
            {dialogOpen && (
                <DragReschduleConfirm
                    open={dialogOpen}
                    onSingleAppt={handelConfirmUpdateDilog}
                    auth={selectData}
                    onClose={handelConfirmCloseDialog}
                    client={clientDetails}
                    data={appointmentsData}
                    timeZones={timeZones}
                />
            )}
            {timeZoneDialog && (
                <CommonConfirmationDialog
                    open={timeZoneDialog}
                    onConfirm={handelClickTimezoneConfirm}
                    onClose={handelTimezoneConfirmcancel}
                    title="TimeZone Conflict"
                    message={"Alert, you are rescheduling this appointment in a different Time Zone. Do you wish continue?"}
                    buttonTitle={"Yes"}
                />
            )}
            {alertOpen && (
                <CommonSuccessDialog
                    open={alertOpen}
                    onClose={handelAlertClose}
                    title="Appointment Alert"
                    message="You cannot reschedule past appointments or those that are not from our system."
                />
            )}
            {outsideWorkAlert && (
                <CommonSuccessDialog
                    open={outsideWorkAlert}
                    onClose={handelOutsideWorkAlertClose}
                    title="Appointment Work Time Alert"
                    message="Appointments cannot be rescheduled outside of standard work hours unless the setting is configured to allow it"
                />
            )}
        </>
    );
};


export default WeekView;